import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=70993ca6&scoped=true&"
import script from "./NPS.vue?vue&type=script&lang=js&"
export * from "./NPS.vue?vue&type=script&lang=js&"
import style0 from "./NPS.vue?vue&type=style&index=0&id=70993ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70993ca6",
  null
  
)

export default component.exports